import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Form } from "react-bootstrap";

export const InputModalCheckBox = ({
  label,
  value,
  handleChange,
  id,
  disabled,
  hidden,
  filter,
  inputBootstrap = true,
}) => {
  return (
    <Row className="mb-2">
      {inputBootstrap ? (
        <Col>
          <Form.Label hidden={hidden(filter, label)}>{label}</Form.Label>
        </Col>
      ) : (
        <Form.Label hidden={hidden(filter, label)}>{label}</Form.Label>
      )}
      <Col>
        <Form.Check
          type="checkbox"
          id={id}
          checked={value}
          onChange={(e) => {
            handleChange(id, e.target.checked);
          }}
          disabled={disabled()}
          hidden={hidden(filter, label)}
          value={value}
        />
      </Col>
    </Row>
  );
};

InputModalCheckBox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.bool,
  handleChange: PropTypes.func,
  disabled: PropTypes.func.isRequired,
  hidden: PropTypes.func.isRequired,
};
